export default "__VITE_ASSET__a22be051__"